import api from './api';

// body - { entity_type: 'USER' | 'DOCUMENT' | ... }
export const listResourcePrivileges = (body) =>
  api.post(`/v1/resources/privilege/list`, body);
/*
Ejemplo de respuesta (200):
{
  "statusCode": 200,
  "headers": { "Content-Type": "application/json" },
  "requestId": "123e4567-e89b-12d3-a456-426614174000",
  "msgCode": [ { "code": "RSC001", "description": "Resources retrieved successfully." } ],
  "body": {
    "privileges": [
      { "privilegeName": "read_users", "entityPrivilegeUuid": "550e8400-e29b-41d4-a716-446655440001" }
    ]
  }
}
*/

// body - { entity_type, entity_uuid, entity_privilege_uuids, users, groups }
export const createResourceGrant = (body) =>
  api.post(`/v1/resources/grant/add`, body);
/*
Ejemplo de respuesta (200):
{
  "statusCode": 200,
  "headers": { "Content-Type": "application/json" },
  "requestId": "123e4567-e89b-12d3-a456-426614174000",
  "msgCode": [ { "code": "RSC001", "description": "Grants created successfully" } ],
  "body": {
    "users_processed": {
      "success": ["550e8400-e29b-41d4-a716-446655440002"],
      "failed": []
    },
    "groups_processed": {
      "success": ["550e8400-e29b-41d4-a716-446655440004"],
      "failed": []
    }
  }
}
*/

// body - { entity_type, entity_uuid, entity_privilege_uuids, users, groups }
export const updateResourceGrant = (body) =>
  api.post(`/v1/resources/grant/update`, body);
/*
Ejemplo de respuesta (200): igual a createResourceGrant pero con "updates" aplicadas
*/

// body - { entity_type, entity_uuid, users, groups }
export const deleteResourceGrant = (body) =>
  api.post(`/v1/resources/grant/delete`, body);
/*
Ejemplo de respuesta (200):
{
  "statusCode": 200,
  "headers": { "Content-Type": "application/json" },
  "requestId": "123e4567-e89b-12d3-a456-426614174000",
  "msgCode": [ { "code": "RSC001", "description": "Grants deleted successfully" } ],
  "body": {
    "users_processed": {
      "success": ["550e8400-e29b-41d4-a716-446655440002"],
      "failed": []
    },
    "groups_processed": {
      "success": ["550e8400-e29b-41d4-a716-446655440004"],
      "failed": []
    }
  }
}
*/

// params - { entity_type, entity_uuid, page, page_size, order_by, order_direction }
export const listResourceGrantees = ({ 
  entity_type, 
  entity_uuid, 
  page = 1, 
  page_size = 20,
  order_by = 'grantee_name',
  order_direction = 'ASC'
}) =>
  api.get(`/v1/resources/grant/list`, { 
    params: {
      entity_type,
      entity_uuid,
      page,
      page_size,
      order_by,
      order_direction
    }
  });
/*
Ejemplo de respuesta (200):
{
  "status_code": 200,
  "msg_code": [ { "code": "RSC001", "description": "Resource grantees retrieved successfully" } ],
  "request_id": "123e4567-e89b-12d3-a456-426614174000",
  "data": [
    {
      "grantee_uuid": "550e8400-e29b-41d4-a716-446655440002",
      "grantee_name": "John Doe",
      "grantee_type": "user",
      "privileges": [
        { "privilege_uuid": "550e8400-e29b-41d4-a716-446655440001", "privilege_name": "READ" }
      ]
    }
  ],
  "meta": {
    "totalItems": 1,
    "totalPages": 1,
    "currentPage": 1,
    "perPage": 20,
    "hasNext": false,
    "hasPrevious": false
  }
}
*/
